export default __webpack_public_path__ + "static/media/explormax.3ef695e8.png";